import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import TimeParse from '../../../services/time-parse';

const ExtraTimeModal = ({
    onHide, show, gracePeriod, locale, ...props
}) => (
    <Modal
        show={show}
        onHide={onHide}
        {...props}
        aria-labelledby="contained-modal-title-lg"
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
                <FormattedMessage id="payment-modal-extra-time-title" defaultMessage="Time expired" />
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>
                <FormattedMessage
                    id="payment-modal-extra-time-text1"
                    values={{ time: TimeParse.fromSecondsToText(gracePeriod, locale) }}
                    defaultMessage="The time to checkout has expired, we have added {time} minutes for you to finish your checkout."
                />
            </p>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={() => onHide()}>
                <FormattedMessage id="payment-modal-extra-time-button" defaultMessage="Close" />
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ExtraTimeModal;



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/modals/extra-time-modal.jsx
 **/